import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, map, filter } from 'rxjs';
import { AppState } from '../../app.state';
import { Store } from '@ngxs/store';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<boolean> => {
  const router = inject(Router);
  const store = inject(Store);

  return store.select(AppState.isLoaded).pipe(
    filter(isLoaded => isLoaded),
    map(() => {
      const isAuthenticated = store.selectSnapshot(AppState.isAuthenticated);

      if (!isAuthenticated) {
        router.navigate(['/login']);
        return false;
      }

      const expectedRoles = route.data.roles as string[];

      if (!expectedRoles || expectedRoles.length === 0) {
        return true;
      }

      const userRole = store.selectSnapshot(AppState.userRole);

      if (userRole && expectedRoles.includes(userRole)) {
        return true;
      }
      else {
        if (!environment.isProd) {
          console.warn('Access Denied: User does not have the required role(s).');
        }
        router.navigate(['/dashboard']);
        return false;
      }
    })
  );
};
